/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Tenantuserrole2Inputs */

const en_entity_tenantuserrole2 = /** @type {(inputs: Entity_Tenantuserrole2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant User Role`)
};

const de_entity_tenantuserrole2 = /** @type {(inputs: Entity_Tenantuserrole2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandanten-Benutzerrolle`)
};

/**
* | output |
* | --- |
* | "Tenant User Role" |
*
* @param {Entity_Tenantuserrole2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_tenantuserrole2 = /** @type {((inputs?: Entity_Tenantuserrole2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Tenantuserrole2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_tenantuserrole2(inputs)
	return de_entity_tenantuserrole2(inputs)
});
export { entity_tenantuserrole2 as "entity_tenantUserRole" }